(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@material-ui/styles"), require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define([, , ], factory);
	else if(typeof exports === 'object')
		exports["bizzaboDesignSystem"] = factory(require("@material-ui/styles"), require("react"), require("react-dom"));
	else
		root["bizzaboDesignSystem"] = factory(root[undefined], root[undefined], root[undefined]);
})(self, (__WEBPACK_EXTERNAL_MODULE__4660__, __WEBPACK_EXTERNAL_MODULE__5225__, __WEBPACK_EXTERNAL_MODULE__4779__) => {
return 